import { clamp } from 'framer-motion';

export const computeVatAmountFromRate = (vatRate: number, total: number) => {
  const rate = vatRate / 100;
  const amount = (rate * total) / (1 + rate);

  return clamp(0, Number.POSITIVE_INFINITY, parseFloat(amount.toFixed(2)));
};

export const computeRateFromVatAmount = (vatAmount: number, total: number) => {
  const rate = vatAmount / (total - vatAmount);

  return clamp(0, 100, parseFloat((rate * 100).toFixed(2)));
};
